import React from "react";

import content from "../../assets/images/sidebarV2/content.svg";
import contentActive from "../../assets/images/sidebarV2/contentActive.svg";
import dashboard from "../../assets/images/sidebarV2/dashboard.svg";
import dashboardActive from "../../assets/images/sidebarV2/dashboardActive.svg";
import Filevault from "../../assets/images/sidebarV2/Filevault.svg";
import filevaultActive from "../../assets/images/sidebarV2/FilevaultActive.svg";
import License from "../../assets/images/sidebarV2/license.svg";
import NavIconDark from "../../assets/images/sidebarV2/Nav-Icon-Dark.svg";
import LicenseActive from "../../assets/images/sidebarV2/licenseActive.svg";
import logout from "../../assets/images/sidebarV2/Logout.svg";
import moduleSVG from "../../assets/images/sidebarV2/module.svg";
import moduleActiveSVG from "../../assets/images/sidebarV2/moduleActive.svg";
import programs from "../../assets/images/sidebarV2/programs.svg";
import programsActive from "../../assets/images/sidebarV2/programsActive.svg";
import Qusetion from "../../assets/images/sidebarV2/question.svg";
import QusetionActive from "../../assets/images/sidebarV2/questionActive.svg";
import Report from "../../assets/images/sidebarV2/Report.svg";
import ReportActive from "../../assets/images/sidebarV2/ReportActive.svg";
import settings from "../../assets/images/sidebarV2/settings.svg";
import settingsActive from "../../assets/images/sidebarV2/settingsActive.svg";
import Support from "../../assets/images/sidebarV2/support.svg";
import SupportActive from "../../assets/images/sidebarV2/supportActive.svg";
import trophy from "../../assets/images/sidebarV2/trophy.svg";
import trophyActive from "../../assets/images/sidebarV2/trophyActive.svg";
import UserGroup from "../../assets/images/sidebarV2/UserGroups.svg";
import Target from "../../assets/images/sidebarV2/UserGroups.svg";
import UserGroupActive from "../../assets/images/sidebarV2/UserGroupsActive.svg";
import TargetActive from "../../assets/images/sidebarV2/UserGroupsActive.svg";
import Users from "../../assets/images/sidebarV2/Users.svg";
import UsersActive from "../../assets/images/sidebarV2/UsersActive.svg";
import AiSolution from "../../assets/images/sidebarV2/AiSolution.svg";
import AiSolutionActive from "../../assets/images/sidebarV2/AiSolutionActive.svg";

export const SideBarItems = {
  DashBoard: {
    icon: <img src={dashboard} alt="dashboard" />,
    iconActive: <img src={dashboardActive} alt="dashboard active" />,
    name: "Dashboard",
    route: "/home/dashboard",
  },
  Users: {
    icon: <img src={Users} alt="user" />,
    iconActive: <img src={UsersActive} alt="user active" />,
    name: "Users",
    route: "/home/users",
  },
  CustomEducation: {
    icon: <img src={NavIconDark} alt="book" />,
    name: "Tailored Education",
    route: null,
    items: [
      {
        icon: <img src={content} alt="articles" />,
        iconActive: <img src={content} alt="articles active" />,
        name: "Create",
        route: "/tailored-content/create",
      },
      {
        icon: <img src={content} alt="articles" />,
        iconActive: <img src={content} alt="articles active" />,
        name: "Custom Assignments",
        route: "/tailored-content/list",
      },
    ],
  },
  Reports: {
    icon: <img src={Report} alt="reports" />,
    iconActive: <img src={ReportActive} alt="reports active" />,
    name: "Reports",
    route: "/home/reports",
  },
  FileVault: {
    icon: <img src={Filevault} alt="secure vault" />,
    iconActive: <img src={filevaultActive} alt="secure vault active" />,
    name: "Secure Vault",
    route: "/home/files",
  },
  UserGroup: {
    icon: <img src={UserGroup} alt="user group" />,
    iconActive: <img src={UserGroupActive} alt="user group active" />,
    name: "User Groups",
    route: "/home/user_groups",
  },
  LicenseManagement: {
    icon: <img src={License} alt="License" />,
    iconActive: <img src={LicenseActive} alt="License active" />,
    name: "License Management",
    route: "/home/billing",
  },
  TargetManagement: {
    icon: <img src={Target} alt="psc targets" />,
    iconActive: <img src={TargetActive} alt="psc targets active" />,
    name: "Target Management",
    route: "/home/targets",
  },
  QuestionDatabase: {
    icon: <img src={Qusetion} alt="program questions" />,
    iconActive: <img src={QusetionActive} alt="program questions active" />,
    name: "Questions Database",
    route: "/programs/questions",
  },
  Programs: {
    icon: <img src={programs} alt="program modules" />,
    iconActive: <img src={programsActive} alt="program modules active" />,
    name: "Programs",
    route: null,
    items: [
      {
        icon: <img src={content} alt="articles" />,
        iconActive: <img src={content} alt="articles active" />,
        name: "Programs Builder",
        route: "/programs/list",
        roles: ["super_admin", "csm", "clinical_team"],
      },
      {
        icon: <img src={content} alt="vow" />,
        iconActive: <img src={content} alt="vow active" />,
        name: "Programs Assignment",
        route: "/programs/assignment",
        roles: ["super_admin", "csm", "clinical_team"],
      },
      {
        icon: <img src={content} alt="vow" />,
        iconActive: <img src={content} alt="vow active" />,
        name: "Survey Questions",
        route: "/programs/survey-questions",
        roles: ["super_admin", "csm", "clinical_team"],
      },
      {
        icon: <img src={content} alt="vow" />,
        iconActive: <img src={content} alt="vow active" />,
        name: "Survey Module",
        route: "/programs/survey-modules",
        roles: ["super_admin", "csm", "clinical_team"],
      },
      {
        icon: <img src={content} alt="vow" />,
        iconActive: <img src={content} alt="vow active" />,
        name: "Survey Assignment",
        route: "/programs/survey-assignment",
        roles: ["super_admin", "csm", "clinical_team"],
      },
      // New items for client_admin
      {
        icon: <img src={content} alt="program library" />,
        iconActive: <img src={content} alt="program library active" />,
        name: "Program Library",
        route: "/programs/library",
        roles: ["client_admin"],
      },
      {
        icon: <img src={content} alt="program assigned" />,
        iconActive: <img src={content} alt="program assigned active" />,
        name: "Programs Assigned",
        route: "/programs/assigned",
        roles: ["client_admin"],
      },
    ],
  },
  Modules: {
    icon: <img src={moduleSVG} alt="program modules" />,
    iconActive: <img src={moduleActiveSVG} alt="program modules active" />,
    name: "Modules",
    route: "/programs/modules",
  },
  Tournament: {
    icon: <img src={trophy} alt="tournaments" />,
    iconActive: <img src={trophyActive} alt="tournaments active" />,
    name: "Tournament Builder",
    route: null,
    items: [
      {
        icon: <img src={trophy} alt="tournaments" />,
        iconActive: <img src={trophyActive} alt="tournaments active" />,
        name: "Tournament Creation",
        route: "/tournaments/create",
      },
      {
        icon: <img src={trophy} alt="tournaments" />,
        iconActive: <img src={trophyActive} alt="tournaments active" />,
        name: "Tournament Management",
        route: "/tournaments/list",
      },
      {
        icon: <img src={trophy} alt="Contest Assignment" />,
        iconActive: <img src={trophyActive} alt="Contest Assignment" />,
        name: "Contest Assignment",
        route: "/tournaments/contestlisting",
      },
    ],
  },
  Support: {
    icon: <img src={Support} alt="support" />,
    iconActive: <img src={SupportActive} alt="support active" />,
    name: "Contact Support",
    route: null,
  },
  Content: {
    icon: <img src={content} alt="articles" />,
    iconActive: <img src={contentActive} alt="articles active" />,
    name: "Content",
    route: null,
    items: [
      {
        icon: <img src={content} alt="vow" />,
        iconActive: <img src={content} alt="vow active" />,
        name: "Videos",
        route: "/feed/vow",
      },
      {
        icon: <img src={content} alt="articles" />,
        iconActive: <img src={content} alt="articles active" />,
        name: "Articles",
        route: "/feed/articles",
      },
      {
        icon: <img src={content} alt="Tips & Pearls" />,
        iconActive: <img src={content} alt="Tips & Pearls" />,
        name: "Tips & Pearls",
        route: "/feed/pearls",
      },
      {
        name: "Content Assignment",
        route: "/feed/assignment",
      },
    ],
  },
};

export const AI_SOLUTIONS = [
  {
    id: 1,
    icon: <img src={AiSolution} alt="dt sensors" />,
    iconActive: <img src={AiSolutionActive} alt="dt sensors active" />,
    name: "Compliance",
    route: null,
    items: [
      {
        name: "Overall Compliance",
        route: "/home/dt-sensors/overall-compliance",
        sensorKey: null, // always visible if parent is shown
      },
      {
        name: "MEAT",
        route: "/home/dt-sensors/meat",
        sensorKey: "MEAT",
      },
      {
        name: "Diagnostic State",
        route: "/home/dt-sensors/diagnostic-state",
        sensorKey: "DIAGNOSTIC_STATE",
      },
      {
        name: "HCC PE Contradiction",
        route: "/home/dt-sensors/hcc-pe-contradiction",
        sensorKey: "CONTRADICTION_DETECTION",
      },
      {
        name: "Buddy Coding",
        route: "/home/dt-sensors/buddy-coding",
        sensorKey: "BUDDY_CODING",
      },
      {
        name: "Pending Signature",
        route: "/home/dt-sensors/pending-signatures",
        sensorKey: "PENDING_SIGNATURE",
      },
    ],
  },
];

export const ACCOUNT = [
  {
    id: 1,
    icon: <img src={settings} alt="settings" />,
    iconActive: <img src={settingsActive} alt="settings active" />,
    name: "Settings",
    route: "/home/settings",
  },
  {
    id: 2,
    icon: <img src={logout} alt="logout" />,
    iconActive: <img src={logout} alt="logout active" />,
    name: "Log Out",
    route: "/logout",
  },
];

export const SIDEBAR_ACCESS_IDENTIFIER = {
  super_admin: Object.keys(SideBarItems),
  client_admin: [
    "DashBoard",
    "CustomEducation",
    "Users",
    "UserGroup",
    "LicenseManagement",
    "FileVault",
    "Reports",
    "TargetManagement",
    "Programs",
    "Support",
  ],
  clinical_team: [
    "QuestionDatabase",
    "Programs",
    "Modules",
    "Content",
    "Tournament",
  ],
  csm: Object.keys(SideBarItems),
};
